module.exports = __webpack_public_path__ + "img/thumbnail_StandardDonkey_m_normal.864415cc.png";